import { uaqiColorsBright as uaqiColors } from '@/modules/UAQI'

export function getLevelsShapes(series, rangeLimits = null) {
	function convertToRanges(arr) {
		if (!Array.isArray(arr) || arr.length === 0) return [];
		
		const result = [];
		
		for (let i = 0; i < arr.length; i++) {
			const min = i === 0 ? 0 : arr[i - 1];
			const max = arr[i];
			const level = i+1
			result.push({ min, max, level });
		}
		
		return result;
	}

	const s = series

	const limits = rangeLimits != null ? rangeLimits : {
		max: Math.max(...s.values.filter(v => v != null)),
		min: Math.min(...s.values.filter(v => v != null)),
	}

	const range = limits.max - limits.min

	const shapes = convertToRanges(series.levels).map(l => {
		// Copy min and max
		let min = l.min
		let max = l.max

		// Remove if out of bounds
		if (min > limits.max) return null
		if (max < limits.min) return null

		// Clipping
		if (min < limits.min) min = limits.min - (range * 0.2)
		if (max > limits.max) max = limits.max + (range * 0.2)
		
		return {
			type: 'rect',
			layer: 'below',
			xref: 'paper',
			x0: 0,
			x1: 1,
			y0: min,
			y1: max,
			fillcolor: uaqiColors[l.level],
			opacity: 0.3,
			line: {
				width: 0
			}
		}
	})

	return shapes
}